export function showToastNotification(data) {
  return {
    type: 'SET_TOAST_DATA',
    data,
  };
}
